/**
 * Home — Modül Karşılama Ekranı.
 * `/lib/moduleMenus.js` kaynağından beslenir. Her kart tıklandığında
 * `/modul/:slug` altındaki alt-öğe hub'ına yönlendirir.
 */
import React from "react";
import { Link } from "react-router-dom";
import Shell from "@/components/Shell";
import { Card } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";
import { getModuleMenus } from "@/lib/moduleMenus";
import { CaretRight } from "@phosphor-icons/react";

export default function Home() {
  const { user } = useAuth();
  const isAdmin = user?.role === "yonetici";
  const modules = getModuleMenus(isAdmin).filter((m) => m.items.length > 0);

  return (
    <Shell hideSiteSelector>
      <div className="space-y-8" data-testid="home-modules-page">
        <div className="border-l-4 border-[#95C11F] pl-4">
          <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#95C11F]">
            Karşılama Ekranı
          </div>
          <h1 className="mt-1 text-3xl sm:text-4xl font-black tracking-tight text-[#1B4776] font-heading">
            Hoş geldiniz{user?.name ? `, ${user.name}` : ""}
          </h1>
          <p className="mt-2 text-sm text-slate-500 max-w-2xl">
            Devam etmek için bir modül seçin. Sol menüden istediğiniz zaman
            modüller arasında hızlıca geçebilirsiniz.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
          {modules.map((m) => {
            const Icon = m.icon;
            return (
              <Link key={m.slug} to={`/modul/${m.slug}`} data-testid={m.testIdCard}>
                <Card className="group p-6 h-full border-l-4 border-l-[#95C11F]/60 hover:border-l-[#95C11F] hover:shadow-lg transition-all rounded-none sm:rounded-sm cursor-pointer bg-white">
                  <div className="flex items-start justify-between gap-4">
                    <div
                      className="w-14 h-14 flex items-center justify-center bg-[#1B4776] group-hover:bg-[#153859] transition-colors"
                      aria-hidden
                    >
                      <Icon size={30} weight="duotone" className="text-white" />
                    </div>
                    <div className="p-2 rounded-full bg-slate-50 group-hover:bg-[#95C11F] transition-colors">
                      <CaretRight
                        size={16}
                        weight="bold"
                        className="text-slate-400 group-hover:text-white transition-colors"
                      />
                    </div>
                  </div>
                  <div className="mt-5">
                    <div className="text-lg font-bold text-[#0F172A] group-hover:text-[#1B4776] transition-colors">
                      {m.title}
                    </div>
                    <p className="mt-1.5 text-xs text-slate-500 leading-relaxed">
                      {m.desc}
                    </p>
                    <div className="mt-3 text-[10px] uppercase tracking-[0.2em] font-bold text-[#95C11F]">
                      {m.items.length} sayfa
                    </div>
                  </div>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </Shell>
  );
}
